import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import * as React from 'react';

import { DictionarySettingsStore } from 'stores/models/fieldsSettings';

import s from './DictionaryFooterControl.module.scss';

type DictionaryFooterControlProps = {
  store: DictionarySettingsStore;
};

const DictionaryFooterControl: React.FC<DictionaryFooterControlProps> = ({
  store,
}) => {
  const footer = React.useRef<HTMLDivElement>(null);

  const onAddNew = React.useCallback(() => {
    if (!footer.current) {
      return;
    }

    store.createNewValue();

    footer.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, [store]);

  return (
    <>
      <Button
        icon={<PlusOutlined />}
        type="primary"
        size="large"
        className={s['bottom-control']}
        onClick={onAddNew}
      />
      <div ref={footer} style={{ padding: 10 }} />
    </>
  );
};

export default DictionaryFooterControl;
